export default __webpack_public_path__ + "static/media/edit_note_black_24dp.711d5bcf.svg";